"use client";

import {
  Skeleton,
  SkeletonText,
  SkeletonCircle,
  Flex,
  Grid,
} from "@chakra-ui/react";

const generateSimpleArr = (qt) => {
  return Array.from(Array(qt).keys());
};

const NewsSkeleton = () => {
  return (
    <Flex flexDir={"column"} rowGap={"36px"}>
      <SkeletonText w={"260px"} />
      <Skeleton
        w={{ base: "100%", md: "70%" }}
        h={{ base: "24px", md: "54px" }}
      />

      <Grid
        templateColumns={{
          base: "minmax(0, 1fr)",
          lg: "2.5fr minmax(387px, 1fr)",
        }}
        columnGap={"30px"}
        rowGap={"30px"}
      >
        <Flex flexDir={"column"} w={"100%"} rowGap={"24px"}>
          <Flex flexDir={"column"} rowGap={"24px"}>
            <SkeletonText />
            <SkeletonText />
            <SkeletonText />
            <Skeleton
              w={{ base: "100%", md: "70%" }}
              h={{ base: "250px", md: "350px" }}
              ms={{ base: "0", md: "40px" }}
            />
            <SkeletonText />
            <SkeletonText />
            <SkeletonText />
          </Flex>
          <Flex alignItems={"center"} columnGap={"8px"}>
            <Skeleton w={"50px"} h={"12px"} />
            <>
              {generateSimpleArr(4)?.map((sk) => (
                <SkeletonCircle key={sk} w={"24px"} h={"24px"} />
              ))}
            </>
          </Flex>
        </Flex>
        <Flex
          flexDir={"column"}
          rowGap={"20px"}
          display={{ base: "none", lg: "flex" }}
        >
          <Skeleton
            {...{ isLoaded: true }}
            w={"100%"}
            bg={"#7E869E11"}
            borderRadius={"12px"}
            p={"20px"}
          >
            <Flex flexDir={"column"} rowGap={"12px"}>
              {generateSimpleArr(3).map((skl) => (
                <Flex key={skl} w={"347px"} h={"125px"} columnGap={"12px"}>
                  <Skeleton minW={"80px"} borderRadius={"10px"} h={"80px"} />
                  <Flex flexDir={"column"} w={"100%"} rowGap={"12px"}>
                    <SkeletonText w={"100%"} />
                    <SkeletonText w={"100%"} />
                  </Flex>
                </Flex>
              ))}
            </Flex>
          </Skeleton>
          <Skeleton
            {...{ isLoaded: true }}
            w={"100%"}
            bg={"#7E869E11"}
            borderRadius={"12px"}
            p={"20px"}
          >
            <Flex flexDir={"column"} rowGap={"12px"}>
              {generateSimpleArr(3).map((skl) => (
                <Flex key={skl} w={"347px"} columnGap={"12px"}>
                  <Flex flexDir={"column"} w={"100%"} rowGap={"12px"}>
                    <SkeletonText w={"100%"} />
                    <Skeleton w={"100%"} h={"1px"} />
                  </Flex>
                </Flex>
              ))}
            </Flex>
          </Skeleton>
          <Skeleton
            {...{ isLoaded: true }}
            w={"100%"}
            bg={"#7E869E11"}
            borderRadius={"12px"}
            p={"20px"}
          >
            <Flex
              flexDir={"column"}
              alignItems={"center"}
              rowGap={"8px"}
              pt={"40px"}
            >
              <SkeletonText w={"80%"} mb={"48px"} />
              <Skeleton h={"36px"} w={"70%"} />
              <Skeleton h={"36px"} w={"70%"} />
            </Flex>
          </Skeleton>
        </Flex>
        <Flex
          flexDir={"column"}
          rowGap={"24px"}
          maxW={{ base: "100%", md: "327px" }}
          display={{ base: "flex", lg: "none" }}
        >
          <Skeleton w={"60%"} h={"254px"} />

          <Flex flexDir={"column"} rowGap={"24px"}>
            {generateSimpleArr(3).map((skl) => (
              <Flex key={skl} w={"100%"} columnGap={"12px"}>
                <Flex flexDir={"column"} w={"100%"} rowGap={"12px"}>
                  <SkeletonText w={"100%"} />
                  <Skeleton w={"100%"} h={"1px"} />
                </Flex>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Grid>
    </Flex>
  );
};

export default NewsSkeleton;
